<!-- Launcher FAB -->
<button
  type="button"
  class="fcw-launcher"
  *ngIf="!isOpen"
  (click)="toggleOpen()"
  matTooltip="Chat with Assistant"
  matTooltipPosition="left"
  aria-label="Open chat assistant"
>
  <mat-icon>smart_toy</mat-icon>
  <span class="fcw-launcher-dot"></span>
</button>

<!-- Chat panel -->
<div class="fcw-panel" *ngIf="isOpen" [class.fcw-fullscreen]="isFullscreen">
  <div class="fcw-header">
    <div class="fcw-header-title">
      <div class="fcw-header-avatar">
        <mat-icon>smart_toy</mat-icon>
      </div>
      <div class="fcw-header-copy">
        <span class="fcw-header-name">Assistant</span>
        <span class="fcw-header-status"><i class="fcw-status-dot"></i>Online</span>
      </div>
    </div>
    <div class="fcw-header-actions">
      <button
        type="button"
        mat-icon-button
        (click)="toggleFullscreen()"
        [matTooltip]="isFullscreen ? 'Restore' : 'Maximize'"
        [attr.aria-label]="isFullscreen ? 'Restore chat window' : 'Maximize chat window'"
      >
        <mat-icon>{{ isFullscreen ? 'close_fullscreen' : 'open_in_full' }}</mat-icon>
      </button>
      <button type="button" mat-icon-button (click)="close()" matTooltip="Close" aria-label="Close chat">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <div class="fcw-body" #chatBody>
    <div
      *ngFor="let msg of messages"
      class="fcw-message-row"
      [ngClass]="msg.sender === 'user' ? 'fcw-row-user' : 'fcw-row-agent'"
    >
      <div class="fcw-avatar" *ngIf="msg.sender === 'agent'">
        <mat-icon>smart_toy</mat-icon>
      </div>

      <div class="fcw-bubble" [ngClass]="msg.sender === 'user' ? 'fcw-bubble-user' : 'fcw-bubble-agent'">
        <div *ngIf="msg.sender === 'agent'" [innerHTML]="msg.formattedText || msg.text"></div>
        <div *ngIf="msg.sender === 'user'">{{ msg.text }}</div>

        <div *ngIf="msg.files?.length" class="fcw-attached-files">
          <div *ngFor="let file of msg.files" class="fcw-attached-file">
            <img *ngIf="isImageFile(file)" class="fcw-attached-thumb" [src]="getFilePreviewUrl(file)" [alt]="file.name" />
            <mat-icon *ngIf="!isImageFile(file)">attach_file</mat-icon>
            <span>{{ file.name }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="fcw-message-row fcw-row-agent" *ngIf="isLoading">
      <div class="fcw-avatar"><mat-icon>smart_toy</mat-icon></div>
      <div class="fcw-bubble fcw-bubble-agent fcw-typing">
        <span class="fcw-dot"></span>
        <span class="fcw-dot"></span>
        <span class="fcw-dot"></span>
      </div>
    </div>
  </div>

  <div class="fcw-footer">
    <div class="fcw-file-preview" *ngIf="selectedFiles.length">
      <div class="fcw-file-chip" *ngFor="let file of selectedFiles">
        <mat-icon>insert_drive_file</mat-icon>
        <span>{{ file.name }}</span>
        <button type="button" mat-icon-button (click)="removeFile(file)" aria-label="Remove file">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <div class="fcw-input-box">
      <input #fileInput type="file" multiple hidden (change)="onFileSelected($event)" />
      <button
        type="button"
        mat-icon-button
        class="fcw-attach-btn"
        (click)="triggerAttach()"
        matTooltip="Attach files"
        aria-label="Attach files"
      >
        <mat-icon>attach_file</mat-icon>
      </button>

      <textarea
        class="fcw-textarea"
        rows="1"
        placeholder="Type your message... (Shift+Enter for new line)"
        [(ngModel)]="currentMessage"
        (keydown.enter)="sendMessageOnEnter($event)"
        [disabled]="isLoading"
      ></textarea>

      <button
        type="button"
        class="fcw-send-btn"
        (click)="sendMessage()"
        [disabled]="isLoading || (!currentMessage.trim() && !selectedFiles.length)"
        aria-label="Send message"
      >
        <mat-icon>send</mat-icon>
      </button>
    </div>
  </div>
</div>
